
<br />
<br />
<br />
<div style="margin:0 auto;width:380px;height:420px;border:1px solid #ddd;padding:30px;background-color:#fff">
  <form [formGroup]="loginForm" novalidate>
    <div style="text-align:center">
      <img src="../../../assets/backgroundImgs/無敵雲服務彩.png" style="width:100%;margin-bottom:10px" />
    </div>
    <br />
    <label style="font-size:medium">帳號</label>
    <br />
    <input formControlName="userId" style="font-size: large; padding: 3px 10px; border: 1px solid #bbb; border-radius: 5px; width: 100%" />
    <br /><br />
    <label style="font-size:medium">密碼</label>
    <br />
    <input formControlName="password" type="password" style="font-size: large; padding: 3px 10px; border: 1px solid #bbb; border-radius: 5px; width: 100%" />
    <br /><br /><br />
    <div style="text-align:center">
      <button mat-raised-button color="primary" (click)="postLogin(loginForm.value)" matTooltip="登入" style="width: 200px">登入</button>
    </div>
  </form>
</div>
